export const AIDA_OPEN_KEY = 'studio.aida.open'
export const AIDA_LAYOUT_MODE_KEY = 'studio.aida.layout.mode'
export const AIDA_LAYOUT_FLOATING_POSITION_KEY = 'studio.aida.layout.floating-position'
export const AIDA_COMPOSER_DRAFT_KEY = 'studio.aida.composer.draft'
export const AIDA_CONVERSATION_ID_KEY = 'studio.aida.conversation.id'
export const AIDA_CONVERSATION_STARTING_NEW_KEY = 'studio.aida.conversation.starting-new'
export const AIDA_LAUNCHER_EDGE_KEY = 'studio.aida.launcher.edge'
export const AIDA_LAUNCHER_PEEK_RATIO_KEY = 'studio.aida.launcher.peek-ratio'
export const AIDA_DOCK_WIDTH_STORAGE_KEY = 'studio.aida.layout.dock-width'
export const AIDA_INTRO_SEEN_KEY = 'studio.aida.intro-seen'
export const AIDA_VIEW_MODE_TIP_SEEN_KEY = 'studio.aida.view-mode-tip-seen'

export const LEGACY_AIDA_OVERLAY_SESSION_KEY = 'cf-aida:overlay'
export const LEGACY_AIDA_DOCK_WIDTH_KEY = 'cf-aida:dock-width'
export const LEGACY_AIDA_LAUNCHER_EDGE_KEY = 'cf-aida:floating-button-edge'
export const LEGACY_AIDA_LAUNCHER_PEEK_RATIO_KEY = 'cf-aida:peek-tab-ratio'
export const LEGACY_AIDA_INTRO_SEEN_KEY = 'aida-intro-seen'
